var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 6.5C16.433 6.5 18 8.067 18 10C18 11.933 16.433 13.5 14.5 13.5H11V12.5H14.5C15.8807 12.5 17 11.3807 17 10C17 8.67452 15.9685 7.58996 14.6644 7.50532L14.5 7.5H11V6.5H14.5ZM9 6.5V7.5H5.5C4.11929 7.5 3 8.61929 3 10C3 11.3255 4.03154 12.41 5.33562 12.4947L5.5 12.5H9V13.5H5.5C3.567 13.5 2 11.933 2 10C2 8.067 3.567 6.5 5.5 6.5H9ZM14.5 9.5C14.7761 9.5 15 9.72386 15 10C15 10.2761 14.7761 10.5 14.5 10.5H5.5C5.22386 10.5 5 10.2761 5 10C5 9.72386 5.22386 9.5 5.5 9.5H14.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.57cc785a.svg";
export { ForwardRef as ReactComponent };